export const SettingAuthSupplierEnum = {
    AUTH_VERIFF: "Autenticacion Veriff"
}
